/**
 * Name: Liberty Vape
 * Plataform: Shopify 
 * Store: https://www.libertyvape.ca/
 * Path: assets/ef.js
 * Note; A loja esta em Liquid, o código abaixo esta minificado dentro do arquivo ef.js
 */

(() => {
  // Verifica se esta na página de produto, pois na pagina de produto tem comportamento diferenciado.
  const isProductPage = document.querySelector("body").classList.contains("template-product");

  // Remove os items com data-attribute [data-region-lock] onde fica os valores das locations para comparação.
  const removeProducts = (region) => {
    const allProduct = document.querySelectorAll("[data-region-lock]");

    allProduct.forEach((elem) => {
      const regions = elem.dataset.regionLock.toLowerCase().replace(/ /g, "").replace(/,/g, ",").split(",");
      elem.removeAttribute("data-region-lock");

      if (regions.includes(region)) {
        elem.remove();
        elem.classList.contains("_redirect") && isProductPage && window.location.replace("/");
      }
    });
  };

  // Criado métodos para gerenciamento do cookie { get , set , delete }.
  const cookie = {
    get: (n) => decodeURIComponent((document.cookie.split("; ").find((c) => c.startsWith(n + "=")) || "").split("=")[1] || ""),
    set: (n, v, d = 365) => (document.cookie = `${n}=${encodeURIComponent(v)}; path=/; expires=${new Date(Date.now() + d * 864e5).toUTCString()}`),
    delete: (n) => (document.cookie = `${n}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`),
  };

  if (cookie.get("AgeVerifyCustom") && cookie.get("_regionLock")) {
    removeProducts(cookie.get("_regionLock"));
  } else {
    cookie.delete("_regionLock");
  }

  // Cofigra o cookie e remove os elementos que contem as locations igual a location selecionada no popup.
  const regionSetup = () => {
    const countryInput = window.AgeVerifycSelect.value,
      provincyInput = window.AgeVerifypSelect.value;

    const regionToblock = countryInput === "canada" ? `${countryInput}-${provincyInput}` : countryInput;

    removeProducts(regionToblock);
    cookie.set("_regionLock", regionToblock);
  };

  // Verifica se existe o cookie para verificar já foi setado o cookie do popup.
  const handleClick = () => {
    const isAVCReady = cookie.get("AgeVerifyCustom") ? true : false;
    isAVCReady && regionSetup();
  };

  window.AVenter.addEventListener("click", handleClick);

  // Function remove ambos os cookies e recarrega a pagina.
  const handleClickListener = (e) => {
    e.preventDefault();
    cookie.delete("_regionLock");
    cookie.delete("AgeVerifyCustom");
    window.location.reload();
  };

  // Elementos que recebem o listener devem possuir o data-attribute - [data-action="change location"].
  document.querySelectorAll('[data-action="change location"]').forEach((el) => el.addEventListener("click", handleClickListener));
})();